<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.platinumService.title.default" small :canGoBack="true"></TopBarBg>
        <PageContent
            class="flex-auto"
            :hasPoweredBy="hasPoweredBy"
            rounded
            :marginTop="55"
            :paddingTop="0"
        >
            <TabNav
                v-model="tab"
                :items="categoryItems"
                :spaceNav="18"
                scrollable
                :fontBold="false"
                fontSize="text-sm"
                borderColorActive="border-primary"
                textColor="text-primary"
                textColorNoneActive="text-gray-secondary"
                paddingX="px-2"
                gap="mx-2"
            ></TabNav>
            <div class="mx-18px my-6">
                <CampaignList
                    ref="campaign-list"
                    :initListConfig="listConfig"
                    :initFilterConfig="filterConfig"
                    :modalController="modalController"
                    @onLoaded="onLoadSuccess()"
                ></CampaignList>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import TabNav from "@/components/Tab/TabNav.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import CampaignList from "../component/CampaignList.vue"

// helper
import Locale from "@/helper/locale/Locale.js";

// mixins
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

// service
// import { SubDashboardConfigBuilder } from "@/core/Campaign/config/DashboardConfigModel.js";
import { CampaignListConfigBuilder, CampaignListFilterConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel"
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel";
// import BzbsDashboard from "@/core/Campaign/service/BzbsDashboard.js";
import BzbsCategory from "@/core/Campaign/service/BzbsCategory";
// import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign";

// config
import ConfigManager from "@/config/ConfigManager";

export default {
    name: 'PlatinumServiceCampaignsPage',
    props: {},
    components: {
        TopBarBg,
        PageContent,
        Footer,
        TabNav,
        ModalMaster,
        CampaignList
    },
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    emits: [],
    data: function () {
        return {
            hasPoweredBy: false,
            categoryItems: [],
            dashboardConfig: ConfigManager.getDashboardConfig(),
            campaignListConfig: ConfigManager.getCampaignPlatinumService(),
            categoryConfig: ConfigManager.getCategoryPlatinumService(),
            tab: 0,
            campaignItems: [],
            listConfig: null,
            filterConfig: null,
            trackingScreenName: 'platinum_service_campaign_list',
        }
    },
    computed: {},
    watch: {
        tab: function (val) {
            this.$router.replace({
                params: {
                    cat: val
                }
            })

            this.generateConfig()
        }
    },
    created: function () {
        this.loadingModal.show()
        this.init()
    },
    mounted: function () {
        this.tracking.screenName(this.trackingScreenName);
        // this.renderCampaigns()
    },
    methods: {
        // init is laoading category
        init: function () {
            this.getCategory().then((items) => {
                if (items != null) {
                    this.categoryItems = items
                    this.setDefaultTab() // set default tab
                }
            })

            // default filter
            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        },
        generateConfig: function () {
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.campaignListConfig)
                .setLocale(Locale.getLocaleCode())
                .setCatId(this.tab)
                .setTop(25)
                .create();

            this.listConfig = listConfig;

            this.$refs['campaign-list'].reinitList(this.listConfig, this.filterConfig)
        },
        getCategory: function () {
            return new Promise((resolve) => {
                this.loadingModal.show()
                var configBuilder = new CategoryConfigBuilder();
                configBuilder.setLocale(Locale.getLocaleCode());
                configBuilder.setConfig(this.categoryConfig)

                var params = configBuilder.create().getParams();
                BzbsCategory.apiGetCategory(params).subscribe((data) => {
                    let items = [];
                    if (data.length == 1) {
                        items = data[0].subcats.map((x) => {
                            return {
                                text: x.name,
                                value: x.id,
                            };
                        });
                    } else {
                        items = data.map((x) => {
                            return {
                                text: x.name,
                                value: x.id,
                            };
                        });
                    }

                    resolve(items)
                }, (err) => {
                    this.loadingModal.hide()
                    this.errorApi(err)
                    resolve(null)
                });
            })
        },
        // getCampaignList: function () {
        //     return new Promise((resolve) => {
        //         let filterConfig = new CampaignListFilterConfigBuilder();

        //         var configBuilder = new CampaignListConfigBuilder();
        //         configBuilder.setLocale(Locale.getLocaleCode());

        //         configBuilder.setCatId(this.tab)
        //         configBuilder.setConfigList(this.campaignListConfig)

        //         var params = configBuilder.create();
        //         BzbsCampaign.apiGetCampaign(params, filterConfig.create()).subscribe(
        //             {
        //                 next: (data) => {
        //                     resolve(data)
        //                 },
        //                 error: (err) => {
        //                     this.errorApi(err)
        //                     resolve(null)
        //                 },
        //             });
        //     })
        // },
        setDefaultTab: function () {
            if (this.$route.params.cat != null) {
                this.tab = this.$route.params.cat
            } else {
                this.tab = this.categoryItems[0].value
            }
        },
        // renderCampaigns: function () {
        //     this.loadingModal.show()

        //     this.getCampaignList().then((items) => {
        //         if (items != null) {
        //             this.campaignItems = items
        //         }

        //         this.loadingModal.hide()

        //         console.log(items)
        //     })
        // }
        onLoadSuccess: function () {
            // this.loadingModal.hide()
        },
    }
}
</script>
